import config from "../config";

const userStorage = {
	get: () => JSON.parse(localStorage.getItem(config.user)),
	set: (user) => localStorage.setItem(config.user, JSON.stringify(user)),
	unset: () => localStorage.removeItem(config.user),
};

export default userStorage;
